<script lang="ts">
  import { _ } from 'svelte-i18n';
  import SessionJoinButton from '../SessionJoinButton.svelte';

  export let compactForm: boolean = false;
  export let phoneView: boolean;

  export let in_progress: boolean;
  export let is_group_session: boolean;
  export let starting_soon: boolean;
  export let joined: boolean;
  export let in_past: boolean;

  export let remaining_time;
  export let starting_in;
  export let starting_at_date;
  export let timestamp;

  // BERLIN-TODO - Reduce the amount of props being passed
  export let joinSession;
  export let session_id;
  export let start_date;
  export let end_date;
  export let current_time;
  export let current_time_highres;

  export let isCalendarExercise: boolean = false;

  $: end_date_obj = new Date(end_date);
  $: not_yet_ended = $current_time_highres < end_date_obj;
</script>

<span class="text" class:compact={compactForm} style={(phoneView && !not_yet_ended ? "margin: 5px 0;":"") + (!phoneView && compactForm ? "text-align: right;":"")}>
  {#if in_progress}
    <h3 class="timestamp blue-text" style={phoneView && "margin: 5px 0;"}>
      {$_("sessions.card.started")} {remaining_time}
    </h3>
  {:else if starting_soon && joined}
    <h3 class="timestamp blue-text" style={phoneView && "margin: 5px 0;"}>
      {$_("sessions.card.starts")} {starting_in != null ? starting_in : "now"}
    </h3>
  {:else}
    <h4 class="date">{starting_at_date}</h4>
    <h3 class="timestamp" style="white-space: normal;">{timestamp}</h3>
    {#if !not_yet_ended && !compactForm}
      <h4 style="margin-top: 20px;"> {$_("sessions.card.already_ended")}</h4>
    {/if}
  {/if}
</span>
{#if not_yet_ended && !isCalendarExercise}
  <span class="buttons" class:compact={compactForm} style={(phoneView ? "flex-grow: 1;" : "") + ((compactForm && !phoneView) ? "margin-left: 20px;":"") + (!compactForm ? "margin-top: 20px; width: 100%;":"")}>
    <SessionJoinButton {phoneView} {in_progress} {is_group_session} {joinSession} {joined} {session_id} {start_date} {end_date} {current_time} {current_time_highres}/>
  </span>
{/if}

<style lang="scss">

.text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.text.compact {
  justify-content: center;

  > h4 {
    margin: 0;
    font-size: 14px !important;
  }
}

.buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  --xert-button-width: 210px;

  &.compact {
    --xert-button-width: auto;
  }
}

.buttons.compact {
  gap: 10px;
  flex-direction: row;
}

.date {
  font-size: 18px !important;
  line-height: 21px !important;
  margin-bottom: 8px;
}

.timestamp {
  font-weight: 500 !important;
  font-size: 22px !important;
  margin: 0;
}

h4 {
  margin: 0;
}

b {
  font-weight: 500 !important;
}

h3.blue-text {
  color: var(--color-xert-blue);
}

</style>